"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimer = void 0;
var useTimer_1 = require("./useTimer");
Object.defineProperty(exports, "useTimer", { enumerable: true, get: function () { return useTimer_1.useTimer; } });
